export default (addForm, requiredFields, errorForm) => {
  

  let isValid = true;

  for (const field in requiredFields) {
    if (!addForm[field] || addForm[field] === "") {
      errorForm[field] = Array.isArray(requiredFields[field])
        ? requiredFields[field][0]
        : requiredFields[field];
      isValid = false;
    } else {
      errorForm[field] = null;
    }
  }

  // Additional check for birth_date format
  if (
    addForm.birth_date &&
    !/^\d{4}-\d{2}-\d{2}$/.test(addForm.birth_date)
  ) {
    errorForm.birth_date = requiredFields.birth_date[1];
    isValid = false;
  }
  console.log("errorForm", { isValid, errorForm });
  

  return { isValid, errorForm };
};
